// Return star rating based on number of stars
// Usage: <GenerateStar numberOfStars={3.5} />
// This will return 3 full stars and 1 half star and 1 empty star

import React from 'react';
import { Star } from '@ui/Icons';
import Image from 'next/image';

type Props = {
  numberOfStars: number;
  size?: number;
};

export default function GenerateStar({ numberOfStars, size }: Props) {
  if (numberOfStars % 1 === 0) {
    // if numberOfStars is an integer
    return (
      <span className="flex items-center">
        {Array.from({ length: numberOfStars }, (_, i) => (
          <Star key={i} className="text-[#FFC107]" size={size} />
        ))}
        {Array.from({ length: 5 - numberOfStars }, (_, i) => (
          <Star key={i} className="text-neutral-100" size={size} />
        ))}
      </span>
    );
  } else {
    // if numberOfStars is fractional
    return (
      <span className="flex items-center">
        {Array.from({ length: Math.floor(numberOfStars) }, (_, i) => (
          <Star key={i} className="text-[#FFC107]" size={size} />
        ))}
        <Image
          src={'/half-star.png'}
          alt="half star"
          width={size ? size : 24}
          height={size ? size : 24}
        />
        {/* <Star className="text-yellow-200" /> */}
        {Array.from({ length: 5 - Math.ceil(numberOfStars) }, (_, i) => (
          <Star key={i} className="text-neutral-100" size={size} />
        ))}
      </span>
    );
  }
}
